import { AxiosInstance } from "axios";
import { ResponseDto } from "@common/ict/model/interface/common";

export class RecruitApi {
  static getRecruitList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/recruit/position/page/list`,
      {
        params: query
      }
    );
  }
  static getRecruitDetail(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/recruit/position/detail`,
      {
        params: query
      }
    );
  }
  static getCode(request: AxiosInstance, data) {
    return request.post<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/recruit/verify/code/get`,
      data
    );
  }
  static submitCommitment(request: AxiosInstance, data) {
    return request.post<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/recruit/commitment/add`,
      data
    );
  }
  static getPlaceList(request: AxiosInstance, params) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/recruit/work/place/list`,
      {
        params: params
      }
    );
  }
}
